/** @module ProductSpec/SizeChartSizesRenderer */
define([
	"dojo/_base/declare",
	"Apparel/ProductSize/_SizesRenderer",
	"csi/store/common",
], function(declare,_SizesRenderer, { DISABLED_PROPERTY }) {

	return declare(_SizesRenderer, {
		/**
		 * @override
		 * Return size range for size chart
		 */
		getSizeRange: function(ctx) {
			return ctx.getNode();
		},

		/**
		 * @override
		 * Disable editing of BaseSize
		 */
		getStoreOptions: function(ctx, h) {
			return {
				onResultItem: (item, store) => {
					const node = ctx.getNode();
					node.SizeChartSubSizeRanges.forEach(function(subSizeRange){
						const subNode = ctx.cache.getNode(subSizeRange);
						var itemUrl = store.getIdentity(item); 
						if (itemUrl == subNode.BaseSize){
							item[DISABLED_PROPERTY] = true;
						}
					})
				}
			}
		},
	});
});